import { getIsCustomSupplierFormModalShown } from '@bridebook/web/lib/shortlist/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import { memo } from 'react';

const CustomSupplierFormModal = lazyComponent(() => import('.'));

const CustomSupplierFormModalLazy: React.FC = () => {
  const show = useSelector(getIsCustomSupplierFormModalShown);

  if (!show) {
    return null;
  }

  return <CustomSupplierFormModal />;
};

export default memo(CustomSupplierFormModalLazy);
